import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvPriceInput";
let LvPriceInput = class LvPriceInput extends UIComponent {
};
LvPriceInput = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvPriceInput);
export default LvPriceInput;
//# sourceMappingURL=script.js.map